import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import brandConfig from './brandConfig';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const whiteLogo = '/logo-blanco.svg'; // Logo blanco por defecto
  const hostname = window.location.hostname.replace(/^www\./, '');
  const { termsAndConditionsRoute } = brandConfig[hostname] || brandConfig.default;
  const { privacyPolicyRoute } = brandConfig[hostname] || brandConfig.default;


  return (
    <Box sx={{ bgcolor: 'grey.900', color: 'grey.100', p: 4 }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {/* Logo: en mobile, aparece primero (order 1); en desktop, se coloca a la derecha (order 2) */}
          <Box sx={{ order: { xs: 1, md: 2 }, mb: { xs: 2, md: 0 } }}>
            <img
              src={whiteLogo}
              alt={t('footer.logoAlt', 'Logo Blanco')}
              style={{ height: 50 }}
            />
          </Box>
          {/* Textos: en mobile, se muestran debajo del logo (order 2); en desktop, a la izquierda (order 1) */}
          <Box sx={{ order: { xs: 2, md: 1 }, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="body1">
              {t('footer.contactEmail', 'contacto@mevuelo.com')}
            </Typography>
            <Typography variant="body1">
              Mevuelo Corp. - All rights reserved © {currentYear}
            </Typography>
            <a
              href={termsAndConditionsRoute}
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2">
                {t('footer.termsAndConditions', 'Terms and Conditions')}
              </Typography>
            </a>
            <a
              href={privacyPolicyRoute}
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2">
                {t('footer.privacyPolicy', 'Privacy Policy')}
              </Typography>
            </a>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
